import React, { useState, useEffect, useRef } from 'react';
import propTypes from 'prop-types';
import { get } from 'lodash';
import styled from 'styled-components';
import { TextField } from '@material-ui/core';
import axios from 'axios';
import Text from '../../../../components/typography';
import { useForm, Controller } from "react-hook-form";
import isPostalCode from 'validator/lib/isPostalCode';
import { theme } from '../../../../themes/default-theme';
import getClosestDealer from '../../../../util/getClosestDealer';
import getClosestDealersByPostcode from '../../../../util/getClosestDealersByPostcode';
import NewDropdown from '../../../../components/ui/NewDropdown';
import latestTimestamp from '../../../../util/latestPostcodeTimestamp';
import {getTopCoordinates} from '../../../../util/getClosestCoodinate';

const SelectDealerContainer = styled.div`
  ${theme.breakpoints.up('md')} {
    margin:${props => props.margin === 'none' ? `0` : `80px 0`};
  }
  ${theme.breakpoints.down('sm')} {
    margin:${props => props.margin === 'none' ? `0` : `60px 0`};
  }

`

const FormItem = styled.div`
  display: block;
  width: 100%;
  text-align: left;
  margin-bottom: 20px;
  }
  ${props => props.display === 0 && `
    display: none;
  `}
`

const FormCol = styled.div`

  ${theme.breakpoints.down('sm')} {
    ${props => props.position === 'left' && `
      margin-bottom: 30px;
    }`
  }

  ${theme.breakpoints.up('md')} {
    ${props => props.position === 'left' ? `
      padding-right: 15px;
    ` : `
      padding-left: 15px;
    `}
  }
`

const Error = styled.p`
  color: ${theme.palette.error.form}
`
const SelectDealerTitle = styled.div`
  h2 {
    color: #2E3238;
    font-weight: 800;
    letter-spacing: normal;
  }
  ${theme.breakpoints.up('md')} {
      padding-bottom: 18px;
      h2 {
        font-size: 20px;
        line-height: 24px;
      }
  }
  ${theme.breakpoints.down('sm')} {
    padding-bottom: 13px;
    h2 {
      font-size: 14px;
      line-height: 24px;
    }
  }
`
const DealerOptionSelected = styled.div`
    border-bottom: 1px solid ${theme.palette.middleGrey};
    h6 {
      color: #758094;
      font-weight: 700;
      margin-bottom: 5px;
    }
    span {
      color: #758094;
    }
  ${theme.breakpoints.up('md')} {
    padding 5px 0 25px;
    h6 {
      font-size: 16px;
      line-height: 23px;
    }
    span {
      font-size: 16px;
      line-height: 23px;
    }
  }
  ${theme.breakpoints.down('sm')} {
    padding 15px 0;
    h6 {
      font-size: 14px;
      line-height: 23px;
    }
    span {
      font-size: 14px;
      line-height: 23px;
    }
  }
`

const SelectDealer = ({ formProps, countryCode, state, dealers, onFormChange, dealersSelect, setDealersSelect, setDefaultDealer, setDealerSummary, title, motorhomeCapvervans }) => {
  const {
    control,
    errors
  } = formProps

  const textFieldProps = {
    as: TextField,
    control: control,
    rules: { required: true },
    variant: "outlined",
    fullWidth: true,
    defaultValue: ''
  }


  const [closestDealersState, setClosestDealers] = useState([])
  const [dealerOptionSelected, setDealerOptionSelected] = useState(null);
  const [postcodes, setPostcodes] = useState([]);
  const [manualyUpdated, setManualyUpdated] = useState(false);

  useEffect(() => {
    if (state.postcode && state.postcode.length === 4) {
      getDealerFromPostcode(state.postcode);
    }
  }, [state.postcode])


  useEffect(() => {
    const getPostcodes = () => {
      //setPostcodeLoading(true);
      axios.get('/data/postcodes.json', {})
      .then(function ( response) {
        // handle success
        const lsPostcodes = {
          date: Date.now(),
          data: response.data
        }
        setPostcodes(lsPostcodes.data);
        localStorage.setItem('postcodes', JSON.stringify(lsPostcodes))
        //setPostcodeLoading(false);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        //setPostcodeLoading(false);
      })
      .then(function () {
        // always executed
        //setPostcodeLoading(false);
      });
    }

    if (localStorage && localStorage.getItem('postcodes')) {
      const lsPostcodes = JSON.parse(localStorage.getItem('postcodes'));
      if (lsPostcodes.data && lsPostcodes.date > latestTimestamp) {
        setPostcodes(lsPostcodes.data);
      } else {
        getPostcodes();
      }
    } else {
      getPostcodes();
    }
  }, [])  

  const getDealerFromPostcode = (postcode) => {

    // Start temp update of hardcoded postcodes before Jayco
    const coffsHarbourPostcodes = ['2408', '2409', '2410', '2411', '2475', '2476', '2481', '2482', '2484', '2474', '2480', '2477', '2479', '2372']

    const isCoffsHarbourPostcode = coffsHarbourPostcodes.indexOf(postcode.toString()) !== -1;

    if (isCoffsHarbourPostcode && motorhomeCapvervans) {

      const _dealers = dealers.filter(item => item.title.toLowerCase() === 'watsons coffs harbour')

      console.log('getDealerFromPostcode', {postcode, coffsHarbourPostcodes, _dealers, isCoffsHarbourPostcode}); 
      
      setDealersSelect(_dealers.map(dealer => {
        return {
          id: dealer.acf_dealers.dealerID,
          value: dealer.acf_dealers.dealerID,
          text: dealer.title,
        }
      }));

      const closest = _dealers[0];

      setDefaultDealer({
        id: closest?.acf_dealers.dealerID,
        value: closest?.acf_dealers.dealerID,
        text: closest?.title,
      });
      
      setDealerSummary(closest);
      setDealerOptionSelected(closest);

      return

    }

    // end

    const closestDealer = getClosestDealer(postcode, dealers, countryCode);

    const matchedDealer = dealers.find(dealer => {
      const dealerPostcodes = get(dealer, 'acf_dealers.postcodes', []);
      if (dealerPostcodes && dealerPostcodes.length > 0) {
        const isMatch = dealerPostcodes.find(i => {
          if (i.toString().indexOf(postcode.toString()) !== -1) {
            return true
          }
        })
        return isMatch
      }
    });

    const formattedDealers = dealers.map(item => {
      return {
        ...item,
        latitude: get(item, 'acf_dealers.latitude', '0'),
        longitude: get(item, 'acf_dealers.longitude', '0')
      }
    })

    const postcodeLocation = postcodes.find(item => item.postcode.toString() === postcode.toString())

    var closestDealers;
    
    if (postcodeLocation && countryCode.toLowerCase() !== 'nz') {
      closestDealers = getTopCoordinates(postcodeLocation, formattedDealers, 1);
    } else {
      closestDealers = closestDealer ? [closestDealer] : getClosestDealersByPostcode(postcode, dealers, 1);
    }

    const getDealer = () => {
      const dealerJson = localStorage.getItem('dealer');
      return dealerJson ? JSON.parse(dealerJson) : null;
    }

    const lsDealer = getDealer();

    const savedDealerFromList = lsDealer ? dealers.find(item => {
      return item.title.toLowerCase() === lsDealer.title.toLowerCase();
    }) : null

    const tempDealerArr = savedDealerFromList ? [savedDealerFromList] : []

    setClosestDealers([...tempDealerArr, ...closestDealers])

    setDealersSelect([...tempDealerArr, ...closestDealers].map(dealer => {
      return {
        id: dealer.acf_dealers.dealerID,
        value: dealer.acf_dealers.dealerID,
        text: dealer.title,
      }
    }));

    // Set default
    const closest = (!manualyUpdated && savedDealerFromList) ? savedDealerFromList : (matchedDealer ? matchedDealer : closestDealers[0]);

    setDefaultDealer({
      id: closest?.acf_dealers.dealerID,
      value: closest?.acf_dealers.dealerID,
      text: closest?.title,
    });
    
    setDealerSummary(closest)
    setDealerOptionSelected(closest);
  }

  const handleDealerUpdate = (select) => {
    if (!select) {
      return;
    }
    const seletedDealer = closestDealersState.find(item => {
      return item.title === select.text
    })
    setDealerSummary(seletedDealer);
    setDealerOptionSelected(seletedDealer);
    onFormChange();
  }

  console.log('dealerOptionSelected', dealerOptionSelected);
  useEffect(() => {
    if (!state.postcode && state.postcode !== formProps.getValues("postcode")) {
      formProps.setValue('postcode', '');
    }
  }, [state]);

  return (
    <SelectDealerContainer>
      {dealers && dealers.length > 0 &&
        title &&
        <SelectDealerTitle>
          <Text variant="h2" uppercase align="center">{title}</Text>
        </SelectDealerTitle>
      }
      <FormItem>
        <Controller
          {...textFieldProps}
          type="tel"
          rules={{
            ...textFieldProps.rules,
            type: 'custom',
            minLength: 3,
            maxLength: 4,
            validate: (val) => isPostalCode(val, 'AU')
          }}
          name={'postcode'}
          placeholder={'Postcode*'}
          error={get(errors, `[postcode]`, false) ? true : false}
          defaultValue={state.postcode || ''}
          onKeyDown={() => setManualyUpdated(true)}
          // value={state.postcode || ''}
        />
        {get(errors, `[postcode]`, false) && <Error>Please add a 4 digit postcode</Error>}
      </FormItem>

      <FormItem 
        display={0}
        // display={dealersSelect.length > 0 ? 1 : 0}
      >
        <Controller
          as={
            <NewDropdown
              variant="outlined"
              showComplete={true}
              error={get(errors, `[dealer]`, false) ? true : false}
              label={null}
              options={dealersSelect}
            />
          }
          control={control}
          rules={{
            ...textFieldProps.rules,
            type: 'custom'
          }}
          defaultValue={typeof (state.dealer) === 'object' ? get(state, 'dealer.value', undefined) : state.dealer || undefined}
          name='dealer'
          onUpdate={handleDealerUpdate}
        />
      </FormItem> 

      {(dealerOptionSelected && dealersSelect.length > 0) &&
        <DealerOptionSelected>
          <Text variant="h6" >{dealerOptionSelected.title}</Text>

          <Text variant="body2" >
            {dealerOptionSelected.acf_dealers.addressLine1}
              {dealerOptionSelected.acf_dealers.suburb 
                && <>, {dealerOptionSelected.acf_dealers.suburb.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}</>
              }
            <br />
            {dealerOptionSelected.acf_dealers.phone}
          </Text>
        </DealerOptionSelected>
      }
    </SelectDealerContainer>
  )
}

SelectDealer.propTypes = {
  setDealerSummary: propTypes.func,
  countryCode: propTypes.string.isRequired
}

SelectDealer.defaultProps = {
  setDealerSummary: () => { },
  countryCode: 'AU'
}

export default SelectDealer